import { render, staticRenderFns } from "./CbsIndAccessCell.vue?vue&type=template&id=20144aca&scoped=true"
import script from "./CbsIndAccessCell.vue?vue&type=script&lang=js"
export * from "./CbsIndAccessCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20144aca",
  null
  
)

export default component.exports